import React from 'react';
import PropTypes from 'prop-types';
import './Input.scss';

const Input = ({checked, className, disabled, id, min, maxLength, name, onChange, onKeyPress, placeholder, type, value}) => {
    return(
        <input
            autoComplete="off"
            checked={checked}
            className={className}
            disabled={disabled}
            id={id}
            maxLength={maxLength}
            name={name}
            onChange={onChange}
            onKeyPress={onKeyPress}
            placeholder={placeholder}
            type={type}
            min={min}
            value={value} />
    );
};

Input.propTypes = {
    //Value for checkBox input
    checked: PropTypes.bool,
    //Class which will be applied to component.
    className: PropTypes.string,
    //Should component be disabled.
    disabled: PropTypes.bool,
    //Html id attribute
    id: PropTypes.string,
    //Max length attribute for input.
    maxLength: PropTypes.number,
    //Input name.
    name: PropTypes.string,
    //Function triggered while user change value in input.
    onChange: PropTypes.func,
    //Function triggered while user press key in input.
    onKeyPress: PropTypes.func,
    //Input placeholder when available.
    placeholder: PropTypes.string,
    //Input type.
    type: PropTypes.string,
    //Input value.
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ])
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/base/Input/Input.js